export default "__VITE_ASSET__BqNI3RgZ__"